import apiUrl from '../../../constants'
import axios from 'axios'
import LocationSummary from './LocationSummary/index.vue';
import BinSummary from './BinSummary/index.vue';
import PalletSummary from './PalletSummary/index.vue';

export default {
  name: 'bag-shipment-query',
  components: {
    'first': LocationSummary,
    'second': BinSummary,
    'third': PalletSummary
  },
  props: [],
  data() {
    return {
      currentTab: 'First',
      componentKey: 0,
      tabs: [{
          key: 'First',
          value: 'Location'
        },
        {
          key: 'Second',
          value: 'Bin'
        },
        {
          key: 'Third',
          value: 'Pallet'
        }
      ],
    }
  },
  computed: {
    currentTabComponent: function() {
      this.componentKey += 1
      return this.currentTab.toLowerCase()
    }
  },
  mounted() {},
  methods: {}
}



// WEBPACK FOOTER //
// ./src/views/components/PalletReportPages/PalletReportPages.js